/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
import clsx from 'clsx';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';

import CloseIcon from '@material-ui/icons/Close';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import ErrorIcon from '@material-ui/icons/Error';

import Button from '@common_button';
import TextField from '@common_textfield';

import { capitalizeEachWord } from '@helper_text';
import useStyles from '@sellermodules/saleschannel/pages/add/components/Modal/style';

const MpDialogContent = (props) => {
    const {
        openDialog, loading, data, error, t, onClose,
    } = props;
    const classes = useStyles();

    if (loading) {
        return (
            <Dialog
                open={openDialog}
                classes={{ paper: classes.dialogContainer }}
                className={classes.dialogContainerRoot}
                fullWidth
                maxWidth="xs"
                scroll="paper"
            >
                <DialogContent className={clsx(classes.content, 'center')}>
                    <CircularProgress className={classes.progress} />
                </DialogContent>
            </Dialog>
        );
    }

    if (error) {
        return (
            <Dialog
                open={openDialog}
                onClose={onClose}
                classes={{ paper: classes.dialogContainer }}
                className={classes.dialogContainerRoot}
                fullWidth
                maxWidth="xs"
                scroll="paper"
            >
                <IconButton classes={{ root: classes.closeButton }} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
                <DialogContent className={clsx(classes.content, 'center')}>
                    <div className="bold f20 text-center">
                        {t('sellersaleschannel:Error')}
                    </div>
                    {error.message}
                </DialogContent>
            </Dialog>
        );
    }

    switch (data?.type) {
    case 'secret_key':
        return <SecretKeyContent {...props} />;
    case 'oauth2':
        return <OauthContent {...props} />;
    default:
        return <SecretKeyContent {...props} />;
    }
};

const SecretKeyContent = (props) => {
    const {
        t, openDialog, formik, formikHelp, data, step, setStep, onClose, initialStep, credentialsField, dataMp,
    } = props;
    const classes = useStyles();

    const {
        channel_name, channel_logo,
    } = data?.channel || {};

    switch (step) {
    // have identifier (click yes)
    case 1:
        return (
            <Dialog
                open={openDialog}
                onClose={onClose}
                classes={{ paper: classes.dialogContainer }}
                className={classes.dialogContainerRoot}
                fullWidth
                maxWidth="xs"
                scroll="paper"
            >
                {initialStep === 0
                && (
                    <IconButton classes={{ root: classes.backButton }} onClick={() => setStep(0)}>
                        <KeyboardBackspaceIcon />
                    </IconButton>
                )}
                <IconButton classes={{ root: classes.closeButton }} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
                <DialogContent className={classes.contentLogo}>
                    <img src={channel_logo || dataMp?.logo} alt="marketplace_logo" className={classes.mpLogo} />
                    <img src="/assets/img/icon-connect.svg" alt="marketplace_connect" className={classes.mpLogo} />
                    <img src="/assets/img/swift-logo.svg" alt="swift_logo" className={classes.mpLogo} />
                </DialogContent>
                <DialogContent className={classes.content}>
                    <div className="py20">
                        <div className="bold f20 text-center">
                            {channel_name}
                        </div>
                    </div>
                    <div className="mb10">
                        {credentialsField?.map((field) => (
                            <div className={classes.formField}>
                                <div className={field.is_required && 'isRequired'}>{capitalizeEachWord(field.name?.split('_')?.join(' '))}</div>
                                <div className={classes.field}>
                                    <TextField
                                        className={classes.textInput}
                                        name={field.name}
                                        error={!!(formik.errors?.[field.name])}
                                        helperText={(formik.errors?.[field.name]) || ''}
                                        onChange={formik.handleChange}
                                        placeholder={`${t('sellersaleschannel:Input')} ${capitalizeEachWord(field.name?.split('_')?.join(' '))}`}
                                    />
                                    {!!field.description
                                    && (
                                        <Tooltip
                                            title={field.description}
                                            placement="bottom"
                                            arrow
                                            classes={{
                                                tooltip: classes.tooltip,
                                                tooltipPlacementBottom: classes.tooltipPlacementBottom,
                                                arrow: classes.tooltipArrow,
                                            }}
                                        >
                                            <IconButton classes={{ root: classes.tooltipButton }}>
                                                <ErrorIcon classes={{ root: classes.tooltipIcon }} />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </DialogContent>
                <DialogActions classes={{ root: classes.dialogActionRoot }}>
                    <Button
                        className={classes.btn}
                        onClick={formik.handleSubmit}
                        disabled={!credentialsField?.length}
                    >
                        {t('sellersaleschannel:Connect')}
                    </Button>
                </DialogActions>
                {/* <DialogContentText classes={{ root: classes.dialogTextRoot }}>
                    {t('sellersaleschannel:Read_our_integration_guide')}
                    {' '}
                    <a href="/" className="bold underline">
                        {t('sellersaleschannel:here')}
                        .
                    </a>
                </DialogContentText> */}
            </Dialog>
        );
        // didn't have identifier (click no)
    case 2:
        return (
            <Dialog
                open={openDialog}
                onClose={onClose}
                classes={{ paper: classes.dialogContainer }}
                className={classes.dialogContainerRoot}
                fullWidth
                maxWidth="xs"
                scroll="paper"
            >
                <IconButton classes={{ root: classes.backButton }} onClick={() => setStep(0)}>
                    <KeyboardBackspaceIcon />
                </IconButton>
                <IconButton classes={{ root: classes.closeButton }} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
                <DialogContent className={classes.contentLogo}>
                    <img src={channel_logo} alt="marketplace_logo" className={classes.mpLogo} />
                    <img src="/assets/img/icon-connect.svg" alt="marketplace_connect" className={classes.mpLogo} />
                    <img src="/assets/img/swift-logo.svg" alt="swift_logo" className={classes.mpLogo} />
                </DialogContent>
                <DialogContent className={classes.content}>
                    <div className="py20">
                        <div className="bold f20 text-center">
                            {channel_name}
                        </div>
                    </div>
                    <div className="mb10">
                        <div className={classes.formField}>
                            <div className="isRequired">{t('sellersaleschannel:Shop_Link')}</div>
                            <TextField
                                className={classes.textInput}
                                name="shop_link"
                                error={!!(formikHelp.errors?.shop_link)}
                                helperText={(formikHelp.errors?.shop_link) || ''}
                                onChange={formikHelp.handleChange}
                                placeholder={`${t('sellersaleschannel:Input')} ${t('sellersaleschannel:Shop_Link')}`}
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions classes={{ root: classes.dialogActionRoot }}>
                    <Button
                        className={classes.btn}
                        onClick={formikHelp.handleSubmit}
                    >
                        {t('sellersaleschannel:Request_Access')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    default:
        return (
            <Dialog
                open={openDialog}
                onClose={onClose}
                classes={{ paper: classes.dialogContainer }}
                className={classes.dialogContainerRoot}
                fullWidth
                maxWidth="xs"
                scroll="paper"
            >
                <IconButton classes={{ root: classes.closeButton }} onClick={onClose}>
                    <CloseIcon className={classes.closeIcon} />
                </IconButton>
                <DialogContent className={classes.contentLogo}>
                    <img src={channel_logo} alt="marketplace_logo" className={classes.mpLogo} />
                    <img src="/assets/img/icon-connect.svg" alt="marketplace_connect" className={classes.mpLogo} />
                    <img src="/assets/img/swift-logo.svg" alt="swift_logo" className={classes.mpLogo} />
                </DialogContent>
                <DialogContent className={classes.content}>
                    <div className="py20">
                        <div className="bold f20 text-center">
                            {channel_name}
                        </div>
                    </div>
                    <div className="mb30 text-center">
                        {t('sellersaleschannel:Do_you_have_a_marketplace_identifier', {
                            marketplace: channel_name,
                            identifier: 'FS ID',
                        })}
                    </div>
                </DialogContent>
                <DialogActions classes={{ root: classes.dialogActionRoot }}>
                    <Button buttonType="outlined" className={classes.btn} onClick={() => setStep(2)}>
                        {t('sellersaleschannel:No')}
                    </Button>
                    <Button
                        className={classes.btn}
                        onClick={() => setStep(1)}
                    >
                        {t('sellersaleschannel:Yes')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
};

const OauthContent = (props) => {
    const {
        t, openDialog, data, dataMp, isReconnect, onClose,
    } = props;
    const classes = useStyles();
    const router = useRouter();

    const {
        channel_name, channel_logo,
    } = data?.channel || {};

    return (
        <Dialog
            open={openDialog}
            onClose={onClose}
            classes={{ paper: classes.dialogContainer }}
            className={classes.dialogContainerRoot}
            fullWidth
            maxWidth="xs"
            scroll="paper"
        >
            <IconButton classes={{ root: classes.closeButton }} onClick={onClose}>
                <CloseIcon className={classes.closeIcon} />
            </IconButton>
            <DialogContent className={classes.contentLogo}>
                <img src={channel_logo} alt="marketplace_logo" className={classes.mpLogo} />
                <img src="/assets/img/icon-connect.svg" alt="marketplace_connect" className={classes.mpLogo} />
                <img src="/assets/img/swift-logo.svg" alt="swift_logo" className={classes.mpLogo} />
            </DialogContent>
            <DialogContent className={classes.content}>
                <div className="py20">
                    <div className="bold f20 text-center">
                        {channel_name}
                    </div>
                </div>
                <div className="flex-column gap16 mb30">
                    <div>
                        {t('sellersaleschannel:Click_the_\"Connect_Now\"_button_and_you_will_be_redirected_to_the_marketplace_page_for_Login_and_Authorization',
                            { marketplace: channel_name })}
                    </div>
                    <div>
                        {t('sellersaleschannel:After_successful_integration_you_can_manage_products_orders_and_shipping_in_Swift_Omnichannel')}
                    </div>
                </div>
            </DialogContent>
            <DialogActions classes={{ root: classes.dialogActionRoot }}>
                <Button
                    className={classes.btn}
                    onClick={async () => {
                        if (isReconnect) {
                            Cookies.set('store_register_seller', dataMp.store_id);
                        } else {
                            Cookies.set('brand_register_seller', dataMp.brandId);
                        }
                        router.push(data.url_oauth2);
                    }}
                >
                    {t('sellersaleschannel:Connect_Now')}
                </Button>
            </DialogActions>
            {/* <DialogContentText classes={{ root: classes.dialogTextRoot }}>
                {t('sellersaleschannel:Read_our_integration_guide')}
                {' '}
                <a href="/" className="bold underline">
                    {t('sellersaleschannel:here')}
                    .
                </a>
            </DialogContentText> */}
        </Dialog>
    );
};

export default MpDialogContent;
